import { FC, useEffect, useState } from 'react'
import { ActivityTable } from 'components/common/ActivityTable'
import { useCollectionActivity } from '@reservoir0x/reservoir-kit-ui'
import axios from 'axios'

type Props = {
  id: string | undefined
  activityTypes: NonNullable<
    Exclude<Parameters<typeof useCollectionActivity>['0'], boolean>
  >['types']
}

type CollectionActivityResponse = ReturnType<typeof useCollectionActivity>
export type CollectionActivityTypes = NonNullable<
  Exclude<Parameters<typeof useCollectionActivity>['0'], boolean>
>['types']

type UsersActivityResponse = ReturnType<typeof useCollectionActivity>
type ActivityResponse = CollectionActivityResponse | UsersActivityResponse

export const CollectionActivityTable: FC<Props> = ({ id, activityTypes }) => {
  const [activities, setActivities] = useState<
    ActivityResponse['data'] | undefined
  >(undefined)
  const [dataSize, setDataSize] = useState<number>(1)
  const [continuation, setContinuation] = useState<string | undefined>(
    undefined
  )

  useEffect(() => {
    setActivities(undefined)
    setContinuation(undefined)
    setDataSize(1)
    const fetchData = async () => {
      try {
        const response = await axios.get('/api/getCollectionActivity', {
          params: {
            collection: id,
            types: activityTypes,
            continuation: undefined,
            limit: 20,
          },
        })
        if (response && response.data) {
          setActivities(response.data.activities)
          setContinuation(response.data.continuation)
        }
      } catch (error) {
        console.error('Failed to fetch stats', error)
      }
    }

    fetchData()
  }, [activityTypes])

  useEffect(() => {
    const fetchData = async () => {
      if (dataSize > 1 && !continuation) return
      try {
        const response = await axios.get('/api/getCollectionActivity', {
          params: {
            collection: id,
            types: activityTypes,
            continuation: continuation,
            limit: 20,
          },
        })
        if (response && response.data) {
          if (activities) {
            setActivities([...activities, ...response.data.activities])
          } else {
            setActivities(response.data.activities)
          }
          setContinuation(response.data.continuation)
        }
      } catch (error) {
        console.error('Failed to fetch stats', error)
      }
    }

    fetchData()
  }, [dataSize])

  return (
    <ActivityTable
      activitise={activities}
      dataSize={dataSize}
      setDataSize={setDataSize}
    />
  )
}
